import React from 'react';
import { motion } from 'framer-motion';
export function ManagedBy() {
  return <section className="py-32" data-id="element-229">
      <div className="max-w-7xl mx-auto px-6" data-id="element-230">
        <div className="glass-panel rounded-3xl p-12 md:p-20 relative overflow-hidden" data-id="element-231">
          {/* Background Glow */}
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent/5 rounded-full blur-[100px] pointer-events-none" data-id="element-232" />

          <div className="relative z-10 max-w-3xl" data-id="element-233">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-accent font-medium tracking-wider text-sm mb-4 uppercase" data-id="element-234">
              Managed by LetLois Agency
            </motion.div>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-bold mb-8" data-id="element-235">
              Software doesn't improve businesses.
              <br data-id="element-236" />
              <span className="text-textSecondary" data-id="element-237">People do.</span>
            </motion.h2>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-textSecondary space-y-6" data-id="element-238">
              <p data-id="element-239">
                Real strategists at LetLois Agency build, manage, and improve
                yours. We don't disappear after setup.
              </p>
              <div className="grid grid-cols-2 gap-4 py-4" data-id="element-240">
                <div className="flex items-center gap-3" data-id="element-241">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-242" />
                  <span className="text-white" data-id="element-243">
                    Continually improve dashboards
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-244">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-245" />
                  <span className="text-white" data-id="element-246">Add new metrics</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-247">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-248" />
                  <span className="text-white" data-id="element-249">Create custom reports</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-250">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent" data-id="element-251" />
                  <span className="text-white" data-id="element-252">Recommend improvements</span>
                </div>
              </div>
              <p className="text-white font-medium text-xl pt-4" data-id="element-253">
                Not software. A partner.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}